import { useState } from 'react';
import {  Button, Card, Drawer, Form, Input, Modal, Radio, Tag, Tooltip, Typography} from 'antd';
import { useTranslation } from 'react-i18next';
import '../../pages.scss';
import './QR.scss';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import { CreditCardFilled, DeleteColumnOutlined, DeleteOutlined, EditOutlined, InfoCircleOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { QRMonitoringAddLabelModal } from './QRMonitoringAddLabelModal';
import { QRMonitoringEditLabelModal } from './QRMonitoringEditLabelModal';
import { authFetch } from '../../../../common/request/authFetch';
import { DrawerPanelTitle, drawerPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

export const QRMonitoringLabelsDrawer = (props: { location: any, onFinish: any, onUpdate: any }) => {

	const { t } = useTranslation();
	const [monitoringQRMap, setMonitoringQRMap] = useState();
	const [updateData, setUpdateData] = useState(false);
	const [addModal, setAddModal] = useState(false);
	const [editModal, setEditModal] = useState(null);
	const {projectGroup } = useAuth();

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${props.location.composeId}/card`, {}, [updateData], 	
    (data: any) => {
        setMonitoringQRMap(data);        
		props.onUpdate();
    });

	const removeCard = async (cardId: string) => {
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${props.location.composeId}/card/${cardId}`, { method: 'DELETE' }).then(()=>{
            setUpdateData(!updateData)
        })
    }

  	return (
		<Drawer
			placement="right"
			width={'50%'}
			open={true}
			onClose={() => props.onFinish()}
			{...drawerPanelStyles}
			title={
				<DrawerPanelTitle
					title="Tarjetas QR para empleados"
					subtitle="Permiten monitorizar el número de escaneos"
					location={props.location}
				/>
			}>		

			<i style={{color:'teal'}}><InfoCircleOutlined/> Añade tarjetas para que tus empleados soliciten reseñas y poder hacer un seguimiento</i>

			<Card className='card-layout' style={{ background:'white', margin: '10px', borderRadius: '10px' }}>
                <span style={{ fontSize: "16px", color:'LightSlateGray' }}>
                    Lista de tarjetas para QR
                </span>                
                <br/>
				{monitoringQRMap && Object.entries(monitoringQRMap).map(([qrId, employee]: any) => {
                    return (
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px', margin:'5px', borderRadius:'25px'}}>                            
							<Tag color='white' style={{color:'slategrey', borderRadius:'20px', border:'solid 1px slategrey'}}><CreditCardFilled/> tarjeta {qrId}</Tag>
							<div><Tag color='slategrey'><UserOutlined/> {employee?.name}</Tag>
								<ButtonLZ type='link' onClick={()=>{setEditModal(qrId)}} size='small' >    																		
									<EditOutlined style={{fontSize: '17px'}}/>												
								</ButtonLZ>																				
								<ButtonLZ type='link' 
									onClick={() => {
										Modal.confirm({
											title: 'Borrar tarjeta',
											//content: !props.isMassive											
											okText: t('dictionary.confirm'),
											cancelText: t('dictionary.cancel'),
											onOk: () => removeCard(qrId)
											})
										}} 
									size='small' >    																		
									<DeleteOutlined style={{fontSize: '17px'}}/>												
								</ButtonLZ>																				
							</div>
                        </div>
                    	)
                    }) 
				}
                <div style={{ display: 'flex', justifyContent:'flex-end', gap: '10px', alignItems: 'center', marginTop: '16px', marginBottom: '16px' }}>
                <ButtonLZ size='small' type='ghost' onClick={() => { setAddModal(true) }}> 
					<PlusOutlined/> Añadir tarjeta
				</ButtonLZ>
			</div>        
            </Card>
			{addModal && 
				<QRMonitoringAddLabelModal
					composeId={props.location.composeId}
					onFinish={() => {
						setAddModal(false);
						props.onUpdate();
						setUpdateData(!updateData);
					}}
				/>} 	
			{editModal && 
				<QRMonitoringEditLabelModal
					composeId={props.location.composeId}
					cardId={editModal}
					onFinish={() => {
						setEditModal(null);
						props.onUpdate();
						setUpdateData(!updateData);
					}}
				/>} 				
		</Drawer>
	)
}